import {Injectable} from '@angular/core';

@Injectable()
export class VatRateService {
    public static VAT21 = 21;
    public static VAT15 = 15;
    public static VAT12 = 12;
    public static VAT0 = 0;

    public static getDefaultVatRate(): number {
        return VatRateService.VAT21;
    }

    public getDefaultVatRate(): number {
        return VatRateService.getDefaultVatRate();
    }

    public getVatRates(): any {
        return [
            VatRateService.VAT21,
            VatRateService.VAT15,
            VatRateService.VAT12,
            VatRateService.VAT0
        ];
    }
}



// WEBPACK FOOTER //
// /app/src/services/vat-rate.service.ts